import { Status } from '@/utils';
import { ERROR_MESSAGE_FIELD } from '@/utils/constants/messages';
import moment from 'moment';
import * as yup from 'yup';

const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
const FILE_SIZE_LIMIT = 10 * 1024 * 1024;

export const formSchemaFn = (
  isActionEdit: boolean,
  isNotPermissionEdit: boolean,
) =>
  yup.object().shape({
    displayOrder: yup
      .number()
      .required('表示順は必須です。')
      .min(1, ERROR_MESSAGE_FIELD.NUMBERICAL_ORDER('表示順'))
      .max(999999999, '表示順は9文字以内で入力してください。')
      .typeError('表示順は数値で入力してください。'),
    status: yup
      .number()
      .oneOf([0, 1], 'ステータスが不正です。')
      .required('ステータスは必須です。')
      .typeError('ステータスが不正です。'),
    prevStatus: yup.number().optional(),
    startAt: yup
      .date()
      .required('公開日時を選択してください。')
      .when(['status', 'prevStatus'], ([status, prevStatus], schema) => {
        if (status !== Status.PUBLIC) return schema;
        return schema.min(
          moment().add(1, 'minute').startOf('minute').toDate(),
          isActionEdit
            ? '公開日時が過去の日時なので、バナーを更新できませんでした。'
            : '公開日時が過去の日時なので、バナーを作成できませんでした。',
        );
      }),
    endAt: yup
      .date()
      .nullable()
      .typeError('公開終了日時は有効な日付である必要があります。')
      .test(
        'endAt-after-startAt',
        '公開終了日時は公開日時より後にしてください。',
        function (value) {
          const { startAt } = this.parent;
          if (!value || !startAt) return true;
          return moment(value).isAfter(moment(startAt));
        },
      ),
    attachment: yup
      .mixed()
      .when(['attachments', 'image'], ([attachments, image], schema) => {
        if (image && (!attachments || !attachments?.fileList?.length)) {
          return schema;
        }
        if (!attachments || !attachments?.fileList?.length) {
          return schema.required(
            ERROR_MESSAGE_FIELD.UPLOAD_MISSING_FILE('バナー画像'),
          );
        }
        return schema
          .test('fileSize', '画像のサイズは10MBを超えています。', (_) => {
            return attachments?.fileList[0]?.size <= FILE_SIZE_LIMIT;
          })
          .test(
            'fileType',
            '画像は .jpg、.png、.jpeg 形式ではありません。',
            (_) => {
              return SUPPORTED_FORMATS.includes(attachments?.fileList[0]?.type);
            },
          );
      }),
    sourceType: yup.string().required('ソースタイプを選択してください。'),
    sourceId: yup.number().required('ソースを選択してください。'),
  } as any);
